import Choices from 'choices.js/src/scripts/choices'

const dropdownsWrappers = document.querySelectorAll('.dropdown__wrapper')

dropdownsWrappers.forEach(dropdown => {

  let choicesSettings = {
    allowHTML: false,
    shouldSort: false,
    searchEnabled: false,
  }

  const select = dropdown.querySelector('.dropdown')

  if (!select) return

  if (dropdown.classList.contains("--with-icon")) {
    const choices = []
    const options = dropdown.querySelectorAll("option")

    options.forEach(option => {
      const imgTag = option.getAttribute('data-icon') ? `<img src="${option.getAttribute('data-icon')}" loading="lazy"> ` : ""
      const isSelected = option.getAttribute("selected") ? true : false
      const choice = {
        value: option.value,
        label: `${imgTag}${option.innerText}`,
        selected: isSelected
      }
      choices.push(choice)
    })
    choicesSettings.allowHTML = true
    choicesSettings = {
      ...choicesSettings,
      choices,
    }
    select.innerHTML = "" // Remove options otherwise choices will incizalize data from options plus new generated choices array

  } else if(dropdown.classList.contains('--location-distance')) {
    const choices = []
    const options = dropdown.querySelectorAll("option")

    options.forEach(option => {
      const isSelected = option.getAttribute("selected") ? true : false
      const choice = {
        value: option.value,
        label: option.innerText,
        selected: isSelected,
        disabled: false
      }
      choices.push(choice)
    })
    choicesSettings = {
      ...choicesSettings,
      choices,
    }
    select.innerHTML = ""
  }

  const dropdownObject = new Choices(select, choicesSettings)
  const dropdownLabel = dropdown.querySelector('.f-label');

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function(mutation) {
      if(mutation.type==="attributes") {
        if(mutation.target.hasAttribute("data-default-value")) {
          dropdownObject.removeActiveItems()
          dropdownObject.setChoiceByValue(mutation.target.getAttribute("data-default-value"))
          mutation.target.removeAttribute("data-default-value")
        }
        if(mutation.target.hasAttribute("disabled")) {
          dropdownObject.removeActiveItems()
          dropdownObject.disable()
          if(dropdownLabel && !dropdownLabel.classList.contains('--disabled')) dropdownLabel.classList.add('--disabled')
        } else {
          dropdownObject.enable()
          if(dropdownLabel && dropdownLabel.classList.contains('--disabled')) dropdownLabel.classList.remove('--disabled')
        }
      }
    })
  })
  observer.observe(select,{attributes: true})
})

